import { useClientId } from "common/SessionContext";
import { onSetCreditAccount } from "common/signalR";
import { CreditApi } from "queries/Credit";
import React from "react";

export const useCredits = () => {
  const [credits, setCredits] = React.useState<number | undefined>(undefined);
  const clientId = useClientId();

  const getCreditsApi = CreditApi.GetCreditAccountByClient.useQuery({ clientId }, { enabled: false });

  React.useEffect(() => {
    // Listen to SignalR for real-time updates on credit balance changes
    const subscription = onSetCreditAccount(dto => setCredits(dto.balance.amount));

    // Fetch initial credit balance 
    getCreditsApi.refetch();

    return subscription.removeEvent;
  }, []);

  React.useEffect(() => {
    if (getCreditsApi.isError) {
      setCredits(prevCredits => prevCredits ?? 0);
      return;
    }
    if (getCreditsApi.data == null) return;

    // If the initial fetch finishes but the credits are already set
    // it means signalR already got the latest state, so we shouldn't override it
    setCredits(prevCredits => prevCredits ?? getCreditsApi.data.data.balance.amount);
  }, [getCreditsApi.data]);

  return credits;
}